"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursoCritico = void 0;
var RecursoCritico = /** @class */ (function () {
    function RecursoCritico() {
        this._id = { DATA_REM: '', TIPO_MAT: '', CENTRO: '', GRUPO: '' };
        this.DATA_REM = '';
        this.TIPO_MAT = '';
        this.CENTRO = '';
        this.DESCRICAO = '';
        this.CAPACIDADE = 0;
        this.NR_DIAS = 0;
        this.GRUPO = '';
        this.DESC_GRUPO = '';
        this.CENTRO_TRAB = '';
    }
    return RecursoCritico;
}());
exports.RecursoCritico = RecursoCritico;
//# sourceMappingURL=RecursoCritico.js.map